
const map = {
    name: "0_2",
    mapType: "surface",
    mapBoundaries: {
        min: {x: 0, y: 4},
        max: {x: 15, y: 14}
    },
    items: [
    ],
    overworld: [
        // right side wall
        {name: "green_rock_wall_04", coordinates: {x: 14, y: 10}},
        {name: "green_rock_wall_04", coordinates: {x: 15, y: 10}},
        {name: "green_rock_wall_01", coordinates: {x: 14, y: 11}},
        {name: "green_rock_wall_01", coordinates: {x: 15, y: 11}},
        {name: "green_rock_wall_01", coordinates: {x: 14, y: 12}},
        {name: "green_rock_wall_01", coordinates: {x: 15, y: 12}},
        {name: "green_rock_wall_01", coordinates: {x: 14, y: 13}},
        {name: "green_rock_wall_01", coordinates: {x: 15, y: 13}},
        {name: "green_rock_wall_01", coordinates: {x: 14, y: 14}},
        {name: "green_rock_wall_01", coordinates: {x: 15, y: 14}},

        // left side wall
        // first 4 lines blocking side wall
        {name: "green_rock_wall_04", coordinates: {x: 0, y: 9}},
        {name: "green_rock_wall_04", coordinates: {x: 1, y: 9}},
        {name: "green_rock_wall_01", coordinates: {x: 0, y: 10}},
        {name: "green_rock_wall_01", coordinates: {x: 1, y: 10}},
        // {name: "green_rock_wall_04", coordinates: {x: 0, y: 11}},
        // {name: "green_rock_wall_04", coordinates: {x: 1, y: 11}},
        {name: "green_rock_wall_01", coordinates: {x: 0, y: 11}},
        {name: "green_rock_wall_01", coordinates: {x: 1, y: 11}},
        {name: "green_rock_wall_01", coordinates: {x: 0, y: 12}},
        {name: "green_rock_wall_01", coordinates: {x: 1, y: 12}},
        {name: "green_rock_wall_01", coordinates: {x: 0, y: 13}},
        {name: "green_rock_wall_01", coordinates: {x: 1, y: 13}},
        {name: "green_rock_wall_01", coordinates: {x: 0, y: 14}},
        {name: "green_rock_wall_01", coordinates: {x: 1, y: 14}},

        {name: "green_rock_wall_04", coordinates: {x: 10, y: 13}},
        {name: "green_rock_wall_01", coordinates: {x: 10, y: 14}},

        {name: "green_rock_wall_04", coordinates: {x: 12, y: 13}},
        {name: "green_rock_wall_01", coordinates: {x: 12, y: 14}},

        // river
        {name: "river0", coordinates: {x: 5, y: 9}},
        {name: "river0", coordinates: {x: 6, y: 9}},
        {name: "river0", coordinates: {x: 5, y: 10}},
        {name: "river0", coordinates: {x: 6, y: 10}},
        {name: "river0", coordinates: {x: 5, y: 11}},
        {name: "river0", coordinates: {x: 6, y: 11}},
        {name: "river0", coordinates: {x: 5, y: 12}},
        {name: "river0", coordinates: {x: 6, y: 12}},
        {name: "river0", coordinates: {x: 5, y: 13}},
        {name: "river0", coordinates: {x: 6, y: 13}},
        {name: "river0", coordinates: {x: 5, y: 14}},
        {name: "river0", coordinates: {x: 6, y: 14}},


        // shoreline
        {name: "river_bank_up_left", coordinates: {x: 4, y: 9}},
        {name: "river_bank_up_right", coordinates: {x: 7, y: 9}},
        {name: "shoreline_bottom", coordinates: {x: 0, y: 8}},
        {name: "shoreline_bottom", coordinates: {x: 1, y: 8}},
        {name: "shoreline_bottom", coordinates: {x: 2, y: 8}},
        {name: "shoreline_bottom", coordinates: {x: 3, y: 8}},
        {name: "shoreline_bottom_half_left", coordinates: {x: 4, y: 8}},
        {name: "river0", coordinates: {x: 5, y: 8}},
        {name: "river0", coordinates: {x: 6, y: 8}},
        {name: "shoreline_bottom_half_right", coordinates: {x: 7, y: 8}},
        {name: "green_bridge", coordinates: {x: 8, y: 8}},
        {name: "shoreline_bottom", coordinates: {x: 9, y: 8}},
        {name: "shoreline_bottom", coordinates: {x: 10, y: 8}},
        {name: "shoreline_bottom", coordinates: {x: 11, y: 8}},
        {name: "shoreline_bottom", coordinates: {x: 12, y: 8}},
        {name: "shoreline_bottom", coordinates: {x: 13, y: 8}},
        {name: "shoreline_bottom", coordinates: {x: 14, y: 8}},
        {name: "shoreline_bottom", coordinates: {x: 15, y: 8}},

        // ocean
        {name: "river0", coordinates: {x: 0, y: 4}},
        {name: "river0", coordinates: {x: 1, y: 4}},
        {name: "river0", coordinates: {x: 2, y: 4}},
        {name: "river0", coordinates: {x: 3, y: 4}},
        {name: "river0", coordinates: {x: 4, y: 4}},
        {name: "river0", coordinates: {x: 5, y: 4}},
        {name: "river0", coordinates: {x: 6, y: 4}},
        {name: "river0", coordinates: {x: 7, y: 4}},
        {name: "river0", coordinates: {x: 8, y: 4}},
        {name: "river0", coordinates: {x: 9, y: 4}},
        {name: "river0", coordinates: {x: 10, y: 4}},
        {name: "river0", coordinates: {x: 11, y: 4}},
        {name: "river0", coordinates: {x: 12, y: 4}},
        {name: "river0", coordinates: {x: 13, y: 4}},
        {name: "river0", coordinates: {x: 14, y: 4}},
        {name: "river0", coordinates: {x: 15, y: 4}},
        {name: "river0", coordinates: {x: 0, y: 5}},
        {name: "river0", coordinates: {x: 1, y: 5}},
        {name: "river0", coordinates: {x: 2, y: 5}},
        {name: "river0", coordinates: {x: 3, y: 5}},
        {name: "river0", coordinates: {x: 4, y: 5}},
        {name: "river0", coordinates: {x: 5, y: 5}},
        {name: "river0", coordinates: {x: 6, y: 5}},
        {name: "river0", coordinates: {x: 7, y: 5}},
        {name: "river0", coordinates: {x: 8, y: 5}},
        {name: "river0", coordinates: {x: 9, y: 5}},
        {name: "river0", coordinates: {x: 10, y: 5}},
        {name: "river0", coordinates: {x: 11, y: 5}},
        {name: "river0", coordinates: {x: 12, y: 5}},
        {name: "river0", coordinates: {x: 13, y: 5}},
        {name: "river0", coordinates: {x: 14, y: 5}},
        {name: "river0", coordinates: {x: 15, y: 5}},
        {name: "river0", coordinates: {x: 0, y: 6}},
        {name: "river0", coordinates: {x: 1, y: 6}},
        {name: "river0", coordinates: {x: 2, y: 6}},
        {name: "river0", coordinates: {x: 3, y: 6}},
        {name: "river0", coordinates: {x: 4, y: 6}},
        {name: "river0", coordinates: {x: 5, y: 6}},
        {name: "river0", coordinates: {x: 6, y: 6}},
        {name: "river0", coordinates: {x: 7, y: 6}},
        {name: "river0", coordinates: {x: 8, y: 6}},
        {name: "river0", coordinates: {x: 9, y: 6}},
        {name: "river0", coordinates: {x: 10, y: 6}},
        {name: "river0", coordinates: {x: 11, y: 6}},
        {name: "river0", coordinates: {x: 12, y: 6}},
        {name: "river0", coordinates: {x: 13, y: 6}},
        {name: "river0", coordinates: {x: 14, y: 6}},
        {name: "river0", coordinates: {x: 15, y: 6}},
        {name: "river0", coordinates: {x: 0, y: 7}},
        {name: "river0", coordinates: {x: 1, y: 7}},
        {name: "river0", coordinates: {x: 2, y: 7}},
        {name: "river0", coordinates: {x: 3, y: 7}},
        {name: "river0", coordinates: {x: 4, y: 7}},
        {name: "river0", coordinates: {x: 5, y: 7}},
        {name: "river0", coordinates: {x: 6, y: 7}},
        {name: "river0", coordinates: {x: 7, y: 7}},
        {name: "river0", coordinates: {x: 8, y: 7}},
        {name: "river0", coordinates: {x: 9, y: 7}},
        {name: "river0", coordinates: {x: 10, y: 7}},
        {name: "river0", coordinates: {x: 11, y: 7}},
        {name: "river0", coordinates: {x: 12, y: 7}},
        {name: "river0", coordinates: {x: 13, y: 7}},
        {name: "river0", coordinates: {x: 14, y: 7}},
        {name: "river0", coordinates: {x: 15, y: 7}},
    ]
}

export default map
